export default "__VITE_ASSET__99b12b0e__"